module.exports = __webpack_public_path__ + "img/domestic-2016-translation-platform.a58257fa.jpg";